import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "./styles.scss";
import crossIcon from "../../images/cross-icon.svg";

const CancelOrder = (props) => {
  return (
    <Modal
      isOpen={props?.trackModal}
      size="md"
      centered
      toggle={() => props.setTrackModal(false)}
      className="RaiseTicketModal"
    >
      <ModalHeader>
        Track Order
        <button
          className="btn"
          onClick={() => {
            props.setTrackModal(false);
          }}
        >
          <img alt="Close" src={crossIcon} />
        </button>
      </ModalHeader>
      <ModalBody>
        <div className="RaiseTicketCards">
            Track  Order
        </div>
      </ModalBody>
    </Modal>
  );
};
export default CancelOrder;